import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AccountImg from "../../../images/Accounting-layout.png";

const Accounting = () => {
  const navigate = useNavigate();

  // Hero Section with Background Image
  const HeroSection = () => (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "50vh", md: "70vh" },
        backgroundImage: `url(${AccountImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
      }}
    >
      {/* Dark Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.45)",
        }}
      />

      {/* Content */}
      <Container
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: "#fff",
            letterSpacing: 2,
            opacity: 0.9,
          }}
        >
          Specialization
        </Typography>

        <Typography
          variant="h3"
          sx={{
            color: "#fff",
            fontWeight: 700,
            mt: 1,
            mb: 2,
            fontSize: { xs: "1.6rem", md: "2rem" },


          }}
        >
          Accounting & Finance
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "rgba(255,255,255,0.85)",
            maxWidth: 600,
            mb: 3,
          }}
        >
          Delivering expert accounting and finance professionals dedicated to
          strengthening your financial operations, ensuring compliance, and
          driving sustainable business growth.
        </Typography>

        <Button
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          sx={{
            backgroundColor: "#1976d2",
            px: 4,
            py: 1.2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "15px",
            "&:hover": {
              backgroundColor: "#115293",
            },
          }}
          onClick={() => navigate("/contact-us")}
        >
          Get in Touch
        </Button>
      </Container>
    </Box>
  );

  return (
    <Box>
      <HeroSection />

      {/* Accounting & Finance Jobs Section */}
      <Box
        sx={{
          py: { xs: 6, md: 10 },
          backgroundColor: "#f5f5f5",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            sx={{
              fontWeight: 700,
              mb: { xs: 6, md: 8 },
              color: "#0a3b4a",
              fontSize: { xs: "2rem", md: "2.4rem" },

            }}
          >
            Accounting and Finance Jobs
          </Typography>

          {/* Row 1 - 4 columns */}
          <Grid
            container
            spacing={{ xs: 6, md: 8 }}
            sx={{ mb: { xs: 6, md: 10 } }}
          >
            {/* Accounts Payable Clerk */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Accounts Payable Clerk
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Accounting clerks are usually entry-level. Candidates should
                  have solid interpersonal skills as well as proficiency with
                  Microsoft Office applications. A high school diploma or
                  equivalent is typically required. Typical duties include
                  matching invoices to purchase orders or vouchers, performing
                  data entry and assisting with the processing of accounts
                  payable and accounts receivable.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Tax Accountant */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Tax Accountant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Candidates for this position typically possess a bachelor&apos;s
                  degree in accounting. Organizations seek individuals with
                  strong organizational, research and communication skills, as
                  well as proficiency with Microsoft Excel and enterprise
                  resource planning (ERP) systems. Typical duties include
                  researching tax laws and regulations, completing corporate tax
                  returns, assisting during tax audits and responding to notices
                  from tax authorities.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Staff Accountant */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Staff Accountant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Staff accountants must possess strong time management and
                  analytical skills, attention to detail and solid communication
                  abilities. A bachelor&apos;s degree in accounting or finance is
                  usually required, along with strong technology skills,
                  particularly expertise with Microsoft Excel. Typical duties
                  include reviewing general ledger accounts and preparing and
                  adjusting journal entries, performing account analysis and
                  reconciliation, maintaining general ledger charts of accounts
                  and assisting with internal control evaluations and accruals.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Payroll Clerk */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Payroll Clerk
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Payroll clerks are often entry-level, although many employers
                  prefer some previous payroll experience. Proficiency with
                  Microsoft Office is required, and knowledge of automated
                  payroll processing systems is highly valued. Payroll clerks
                  should have a high school diploma or equivalent and strong
                  communication, customer service and organizational skills.
                  Typical duties include performing data entry and reconciling
                  timecards, distributing paychecks and statements to
                  departments and answering inquiries from employees and
                  vendors.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Row 2 - 4 columns */}
          <Grid
            container
            spacing={{ xs: 6, md: 8 }}
            sx={{ mb: { xs: 6, md: 10 } }}
          >
            {/* Financial Analyst */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Financial Analyst
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Financial analysts must be able to communicate with all levels
                  of the organization and frequently interact with executive
                  management and project teams. A strong knowledge of general
                  accounting procedures, reporting and expense analysis and
                  journal posting is required. A bachelor&apos;s degree in
                  business, accounting or finance is required; an MBA and
                  certifications such as CPA are preferred. Typical duties
                  include preparing profit and loss models and management
                  reports, forecasting financial outcomes in Excel, maintaining
                  confidential financial information and performing budgeting
                  variance and forecasting analysis.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Data Entry Clerk */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Data Entry Clerk
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Data entry clerks usually require at least two years of
                  relevant experience, strong attention to detail and
                  proficiency with Microsoft Office. A high school diploma or
                  equivalent is typically required. Typical duties include
                  inputting information quickly and accurately from a variety of
                  sources into a computer database and taking customer orders
                  and entering them into a tracking system.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Credit and Collections Clerk */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Credit and Collections Clerk
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Credit and collections clerk positions are often entry-level,
                  although many firms seek several years of experience.
                  Candidates should have excellent customer service,
                  negotiation, communication and analytical skills. An associate
                  or bachelor&apos;s degree in accounting or a related area is
                  preferred. Typical duties include creating and maintaining
                  credit history files, assessing creditworthiness using risk
                  management tools, supporting collection efforts, documenting
                  daily collections activity and researching account disputes
                  and billing discrepancies.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Cost Accounting Manager */}
            <Grid item xs={12} md={3}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Cost Accounting Manager
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Cost accounting managers need strong communication,
                  interpersonal, analytical and technology skills. Employers
                  seek individuals with at least five years of experience and a
                  bachelor&apos;s degree in accounting or finance; certifications
                  such as CPA or CMA and an MBA are highly valued. Typical
                  duties include developing cost standards, designing and
                  implementing cost accounting systems, analyzing production
                  costs and recommending changes, overseeing annual physical
                  inventory and supervising cost and inventory accounting staff.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "120px solid transparent",
                    borderRight: "120px solid transparent",
                    borderTop: "80px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>

          {/* Row 3 - 3 columns */}
          <Grid container spacing={{ xs: 6, md: 8 }}>
            {/* Bookkeeper */}
            <Grid item xs={12} md={4}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Bookkeeper
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Candidates for bookkeeping roles should have solid
                  communication, organizational and customer service skills.
                  Technical requirements may include proficiency with Microsoft
                  Excel or QuickBooks. A high school diploma or equivalent is
                  expected, and many employers seek at least three years of
                  experience. Typical duties include processing accounts payable
                  and accounts receivable, managing bank reconciliations and
                  payroll processing and posting journal entries.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "150px solid transparent",
                    borderRight: "150px solid transparent",
                    borderTop: "90px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Billing Clerk */}
            <Grid item xs={12} md={4}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Billing Clerk
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Billing clerks should have basic knowledge of Microsoft Office
                  applications, strong communication skills and a customer
                  service focus. Positions are often entry-level, although some
                  employers prefer previous billing experience. Typical duties
                  include processing bills, preparing journal entries of
                  adjustments to billings and communicating with customers
                  regarding billing adjustments.
                </Typography>

                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "150px solid transparent",
                    borderRight: "150px solid transparent",
                    borderTop: "90px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>

            {/* Accounting Manager */}
            <Grid item xs={12} md={4}>
              <Box sx={{ px: { xs: 1, md: 3 } }}>
                <Typography
                  variant="subtitle1"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 600,
                    mb: 1,
                    fontSize: { xs: "1.1rem", md: "1.3rem" },
                  }}
                >
                  Accounting And Finance
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#102a6b",
                    fontWeight: 700,
                    mb: 2,
                    fontSize: { xs: "1.6rem", md: "2rem" },
                  }}
                >
                  Accounting Manager
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    fontSize: "15px",
                    fontWeight: 500
                  }}
                >
                  Accounting managers generally need at least five years of
                  experience and strong communication, technology and analytical
                  abilities. Employers expect a bachelor&apos;s degree in
                  accounting or finance and often prefer an MBA or CPA. Typical
                  duties include preparing and reviewing ledger entries and
                  reconciliations, maintaining the general ledger system,
                  preparing monthly, quarterly and annual financial statements,
                  researching accounting issues for compliance with GAAP,
                  coordinating the budget process and hiring, training and
                  supervising accounting staff.
                </Typography>
                <Box
                  sx={{
                    width: 0,
                    height: 0,
                    borderLeft: "150px solid transparent",
                    borderRight: "150px solid transparent",
                    borderTop: "90px solid #000",
                    mx: "auto",
                    mt: 4,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default Accounting
